import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// Layout Components
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";

// Pages
import HomePage from "./pages/HomePage";
import MissionPage from "./pages/MissionPage";
import PricingPage from "./pages/PricingPage";
import GetAppPage from "./pages/GetAppPage";
import ContactUsPage from "./pages/ContactUsPage";
import CustomersPage from "./pages/CustomersPage";
import CustomersGetAppPage from "./pages/CustomersGetAppPage";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Defer so the destination page renders & lays out before we scroll
      const id = hash.slice(1);
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo(0, 0);
        }
      });
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <div className="App min-h-screen bg-[#FAFAF9]">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mission" element={<MissionPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/get" element={<GetAppPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/customers/get" element={<CustomersGetAppPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
